export const MENTAL_HEALTH_QUESTIONNAIRE_KEY = 'mental_health_questionnaire';
export const SUGGESTED_MSG_KEY = 'suggested_message';
